import {configureStore} from '@reduxjs/toolkit';
import {useDispatch, useSelector, type TypedUseSelectorHook} from 'react-redux';
import rootReducer from './reducers';

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
/** Binds dispatch calls to the browser store's thunk-aware dispatch type. */
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;
/** Binds selector callbacks to the browser store shape so feature slices stay type-safe. */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
